import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.aufgabe-bild';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenAufgabeBildEffects {

    AufgabeBild$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_AUFGABE_BILD),
        mergeMap((x: ac.GetAufgabeBildAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getAufgabeBild(x.aufgabe_id, x.bild_id).pipe(
                map((result: any) => {
                    return new ac.GetAufgabeBildErfolgreichAction(result, x.aufgabe_id, x.bild_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetAufgabeBildFehlerAction(error, x.aufgabe_id, x.bild_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VorlagenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VorlagenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.VorlagenQueryService);
        }
        return this.service;
    }
}
